import { useTranslation } from 'react-i18next';
import { toolbarButtons } from '../../config/withdrawalStatusConfig';

export interface StatusToolbarProps {
  onStatusChange?: (status?: string) => void;
  active: string;
  setActive: (key: string) => void;
}

export const StatusToolbar = ({ onStatusChange, active, setActive }: StatusToolbarProps) => {
  const { t } = useTranslation('withdrawalsModule');

  return (
    <div
      className="flex w-full bg-card-bg rounded-lg text-sm p-1 overflow-x-auto scrollbar-hide light:border-card-border light:border"
      style={{ WebkitOverflowScrolling: 'touch' }}
    >
      {toolbarButtons.map((btn) => (
        <a
          key={btn.key}
          href={btn.link}
          onClick={(e) => {
            e.preventDefault();
            setActive(btn.key);
            if (onStatusChange) {
              onStatusChange(btn.status);
            }
          }}
          className={`px-3 py-1 rounded hover:bg-hover-press whitespace-nowrap ${
            active === btn.key ? 'bg-hover-press' : ''
          }`}
        >
          {t(`toolbar.${btn.key}`)}
        </a>
      ))}
    </div>
  );
};
